import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href"];
import { mctRequest } from '@/api/axios';
import { ref, onMounted, toRefs } from 'vue';
import { formatInTimeZone } from 'date-fns-tz';
import { storeToRefs } from 'pinia';
import { useUserDefaultSettingStore } from '@/store/user';
export default /*@__PURE__*/_defineComponent({
  __name: 'PagerDutyTable',
  props: {
    serverId: {}
  },
  setup(__props) {
    const store = useUserDefaultSettingStore();
    const {
      timeZoneArea
    } = storeToRefs(store);
    const props = __props;
    const {
      serverId
    } = toRefs(props);
    const tableData = ref([]);
    // @ts-ignore
    const pagerDutySite = ref(window.envConfig?.pagerDutySite);
    const getPagerDuty = async () => {
      tableData.value = [];
      const config = {
        url: `/pd?serverId=${serverId.value}`
      };
      const {
        item
      } = await mctRequest.request(config);
      tableData.value = item;
    };
    const formatTime = time => {
      formatInTimeZone(new Date(time), timeZoneArea.value, 'yyyy-MM-dd HH:mm:ss');
    };
    onMounted(() => {
      getPagerDuty();
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_table, {
        data: tableData.value,
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "pdNumber",
          label: "PD Number"
        }, {
          default: _withCtx(scope => [_createElementVNode("a", {
            href: pagerDutySite.value + scope.row.pdNumber,
            class: "mct-blue",
            target: "_blank"
          }, " PD" + _toDisplayString(scope.row.pdNumber), 9, _hoisted_1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "subject",
          label: "Summary",
          width: "400"
        }), _createVNode(_component_el_table_column, {
          prop: "mailTo",
          label: "PD Service"
        }), _createVNode(_component_el_table_column, {
          prop: "pdStatus",
          label: "Status"
        }), _createVNode(_component_el_table_column, {
          label: "Date"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(formatTime(scope.row.sendTime)), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]);
    };
  }
});